<template>
  <LineChart :chart-data="chartData" :chart-options="chartOptions" />
</template>

<script>
import LineChart from '../../../components/LineChart/lineChart.vue'
export default {
  name: "amountStatCard",
  components: { LineChart },
  props: {
    data: {type: Object, required: true}
  },
  data: function () {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {position: "top", display: false,},
          tooltip: {
            backgroundColor: '#4A6D5B', displayColors: false,
            padding: 15, boxPadding: 10,
            bodyFont: {size: 18, family: "'Heading-Double', 'Heading-Medium', 'Graphik', sans-serif"},
            titleFont: {size: 18, family: "'Heading-Double', 'Heading-Medium', 'Graphik', sans-serif"},
            callbacks: {
              label: function(context) {
                return (context.dataset.label??'')+context.parsed.y + ' ₽';
              }
            }
          },
        },
        scales: {y: {min: 0,}, x: {min: 0,}},
        transitions: {
          show: {animations: {x: {from: 0}, y: {from: 0}}},
          hide: {animations: {x: {to: 0}, y: {to: 0}}}
        },
      },
      chartData: {
        datasets: [{
          //label:"Сумма заработка",
          pointBackgroundColor:"white",
          pointBorderColor:"rgba(91,137,179,0.5)",
          backgroundColor:"#5B89B3",
          borderColor:"#5B89B3",
          borderWidth:3,
          cubicInterpolationMode: 'monotone',
          tension: 0.4,
          data: []
        }],
        labels: []
      }
    }
  },
  mounted() {
    this.chartData.labels = Object.keys(this.data)
    this.chartData.datasets[0].data = Object.values(this.data)
  }
}
</script>
